export const RELY_COMMAND_PACKAGE_KEY = 'rely_membership';

export const isRelyCommandSubscription = (subscription = {}) =>
  subscription.packageKey === RELY_COMMAND_PACKAGE_KEY ||
  subscription.package_key === RELY_COMMAND_PACKAGE_KEY ||
  subscription.planType === RELY_COMMAND_PACKAGE_KEY ||
  subscription.plan_type === RELY_COMMAND_PACKAGE_KEY;

export const hasRelyCommandEntitlements = (subscription = {}) => {
  const entitlements = subscription.entitlements || [];

  return (
    isRelyCommandSubscription(subscription) ||
    entitlements.some(
      (entitlement) =>
        entitlement.startsWith('invoicing.') ||
        entitlement.startsWith('proposals.')
    )
  );
};

export const hasRelyCommandAccess = ({
  subscription = {},
  hasRecurringSubscription = false,
} = {}) =>
  Boolean(hasRecurringSubscription && hasRelyCommandEntitlements(subscription));
